import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { RBAC_PERMISSIONS } from '@/constants/permissions';
import { z } from 'zod';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { UserEditPage } from '@/features/users/pages/UserEditPage';

const searchSchema = z.object({
  userId: z.number(),
  from: z.string().optional(),
});

export const Route = createFileRoute('/_auth/users/edit')({
  beforeLoad: () => requirePermission(RBAC_PERMISSIONS.USER_EDIT),
  validateSearch: searchSchema,
  component: function UserEditRoute() {
    const { userId, from } = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Edit User">
        <UserEditPage userId={userId} fallbackPath={from} />
      </ErrorBoundary>
    );
  },
});
